import React from "react";
import styles from "./AppFooter.module.css";

export const AppFooter = () => {
  return (
    <footer className={styles.footer}>
      © {new Date().getFullYear()}{" "}
      <a href="https://www.odessaseparator.com" target="_blank" rel="noreferrer">
        OSI
      </a>
    </footer>
  );
};
